<template>
    <div>
        <nav-breadcrumb :menu="[{label: '他项出入库列表'}]"/>
        <el-tabs v-model="status">
            <el-tab-pane label="待审核" name="Pending Approval" />
            <!-- <el-tab-pane label="审核通过" name="Approved" />-->
            <el-tab-pane label="已审核" name="Approved,Rejected" />
        </el-tabs>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "HisWarrantApproveList",
        data(){
            return{
                status: 'Pending Approval',
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '出入库单号',
                        field: 't__applicationNo'
                    },
                    {
                        label: '出入库类型',
                        field: 't__applicationTypeCode',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '出入库原因',
                        field: 't__reason'
                    },
                    {
                        label: '贷款编号',
                        field: 't__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 't__customerName'
                    },
                    {
                        label: '申请时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '状态',
                        field: 't__applicationStatus',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 't__nodeName',
                        formatter: function (r,c,v) {
                            if(r.t__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                   /* {
                        label: '缩图',
                        field: 'w__hisWarrant',
                        component: 'preview-image-component'
                    },*/
                    {
                        label: '操作',
                        opts:[
                            /*{
                                label: '审核',
                                class: 'el-icon-check',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approved',
                                            query: {
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__applicationStatus == 'Pending Approval'  && row.t__roleId==this.tableData.variables.r0

                                }
                            },*/
                            {
                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if(item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approved',
                                            query: {
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__hasRole == 'true' &&row.t__applicationStatus == 'Pending Approval'

                                }
                            },
                           /* {
                                label: '副总复核',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approved',
                                            query: {
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__hasRole == 'true' &&row.t__applicationStatus == 'Pending Approval'  && row.t__roleId==this.tableData.variables.r0a

                                }
                            },
                            {
                                label: '总经理审批',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approved',
                                            query: {
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__hasRole == 'true' &&row.t__applicationStatus == 'Pending Approval'  && row.t__roleId==this.tableData.variables.r2

                                }
                            },
                            {
                                label: '综合岗确认',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approved',
                                            query: {
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__hasRole == 'true' &&row.t__applicationStatus == 'Pending Approval'  && row.t__roleId==this.tableData.variables.r3

                                }
                            },*/
                            {
                                label: '详情',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                applicationId: row.t__applicationId,
                                                applicationTypeCode:row.t__applicationTypeCode,
                                            }
                                        }
                                    )
                                },
                            },
                            {
                                label: '撤回',
                                class: ' el-icon-back',
                                clickHandler: (index, row) => {
                                    this.$confirm('是否确认撤回出库申请？一旦撤回，审核人将无法再审核','撤回出库')
                                        .then(()=> {
                                            xhr.RevokeApprovingHisWarrantCheckout(
                                                {
                                                    't.applicationId': row.t__applicationId,
                                                },
                                                res=> {
                                                    try{
                                                        if(res.data.status == 'success') {
                                                            this.getData()
                                                        }else{
                                                            this.$message.error(res.data.msgs[0].text)
                                                        }

                                                    }catch (e) {

                                                        this.$message.error(error.msgs[0].text)

                                                    }
                                                }
                                            )
                                        })
                                        .catch(()=> {

                                        })
                                },
                                conditions: row=> {
                                    return row.t__applicationStatus==='Pending Approval'&&this.$store.state.userInfo.u__userId === row.t__createdBy && row.t__applicationTypeCode === 'HWI'

                                }
                            },

                            {
                                class: 'el-icon-printer',
                                name: '打印材料',
                                clickHandler: (index, row)=>{
                                    this.$router.push(
                                        {
                                            path: 'HisWarrantPrint',
                                            query: {
                                                transactionId: row.fi__transactionId,
                                                applicationId: row.t__applicationId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode == 'HWI'

                                }
                            },

                            {
                                class: 'el-icon-download',
                                name: '打印释放他项权证审批表',
                                clickHandler: (index, row)=>{
                                    this.exportPdf2(index, row)
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode == 'HWI' &&row.t__applicationStatus == 'Approved'

                                }
                            }

                        ]
                    }
                ],

                tableData: {
                    count: 0,
                    data: []
                },

                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        t__reason:'',
                        t__transactionNo:'',
                        t__customerName:'',
                        t__applicationDate:[],
                        t__applicationTypeCode:'',
                    },
                    columns: [
                        {
                            label: '出入库类型',
                            component: 'el-select',
                            field: 't__applicationTypeCode',
                            options:[
                                {
                                    label:'出库',
                                    value:'HWI'
                                },
                                {
                                    label:'入库',
                                    value:'HWR'
                                }
                            ]
                        },
                        {
                            label: '出入库原因',
                            component: 'el-select',
                            field: 't__reason',
                            options:[
                                {
                                    label:'结清释放',
                                    value:'结清释放'
                                },
                                {
                                    label:'借贷抵押',
                                    value:'借贷抵押'
                                },
                                {
                                    label:'债权转移',
                                    value:'债权转移'
                                }
                            ]
                        },
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 't__transactionNo'
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 't__customerName'
                        },
                        {
                            label: '申请时间',
                            component: 'date-range-picker',
                            field: 't__applicationDate',
                            op: ['gteq', 'lteq'],
                            span: 12
                        },



                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.search.t.applicationStatus' : this.status,
                    'xlist.search.t.applicationStatus.op' : 'in',
                    'xlist.sort.dataField': 't.applicationDate',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getHisWarrantTxList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                            this.tableData.data.forEach(item=>{
                                item.t__nodeName = (this.tableData.variables.procInfo.find(item2=>item2.type ===item.t__nodeType )||{}).name


                            })
                        }catch(e){

                        }
                    })

            },
            exportPdf2: function (index, row) {
                try {
                    window.open('/ix/fang/financing/HisWarrantApprove.jasper?applicationId='+row.t__applicationId)
                }
                catch (e) {

                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantApproveList.vue